/* Display translation contract shared by homepage, product chat and download chat. */
(function (root) {
  'use strict';
  var selectedLanguage = null;
  ['homepage:language-change', 'dialog:language-change', 'universe-bean-language-change'].forEach(function (type) {
    root.addEventListener(type, function (event) {
      var detail = event.detail || {};
      var value = detail.lang || detail.language || detail.code;
      if (value) selectedLanguage = normalize(value);
    });
  });
  function normalize(value) {
    if (value === 'nan-TW') return 'zh-TW';
    if (value === 'nan-TW') return 'zh-TW';
    return ['sichuan', 'shanghai', 'henan', 'cn', 'zh-CN'].includes(value) ? 'zh' : (value || 'zh');
  }
  function current() {
    if (selectedLanguage) return selectedLanguage;
    var language = root.AppCenterLanguage && root.AppCenterLanguage.current;
    if (!language && root.OpeningCopy) language = root.OpeningCopy.getLanguage();
    if (!language && root.HomepageLanguage) language = root.HomepageLanguage.getLanguage();
    if (!language) {
      try { language = root.localStorage.getItem('universe-power-language'); } catch (_) {}
    }
    return normalize(language);
  }
  function read(payload, requested) {
    if (payload && Number(payload.code) >= 400) throw new Error(payload.msg || '服务请求失败');
    var data = payload && payload.data || payload || {};
    var state = data.translation && data.translation.status;
    var language = normalize(data.language);
    if (state === 'translated') {
      if (language !== requested) throw new Error('返回语种与请求不一致，请重试');
      return {status:state, language:language, message:''};
    }
    if (requested === 'zh' && (!state || state === 'skipped')) {
      return {status:'skipped', language:'zh', message:''};
    }
    return {status:'failed', language:'zh', message:'翻译暂时不可用，已保留原文。'};
  }
  function render(target, translation) {
    if (!target || !translation) return;
    target.dataset.apiContent = '';
    target.dataset.languageStatic = '';
    target.dataset.translationStatus = translation.status;
    target.lang = translation.language === 'zh' ? 'zh-CN' : translation.language;
    target.dir = ['ar', 'ur'].includes(translation.language) ? 'rtl' : 'ltr';
    if (translation.message) {
      var notice = target.ownerDocument.createElement('p');
      notice.className = 'bean-chat-api-status is-error';
      notice.setAttribute('role', 'status');
      var language = current();
      notice.textContent = root.HomepageLocales ? root.HomepageLocales.translate(translation.message, language) : translation.message;
      notice.lang = language === 'zh' ? 'zh-CN' : language;
      notice.dir = ['ar', 'ur'].includes(language) ? 'rtl' : 'ltr';
      target.appendChild(notice);
    }
  }
  async function ensure(text, requested, signal) {
    requested = normalize(requested);
    if (requested === 'zh') return {text:text, translation:{status:'skipped',language:'zh',message:''}};
    try {
      const local = await (root.OpeningCopy && root.OpeningCopy.translateText ? root.OpeningCopy.translateText(text, requested) : null);
      if (local) return {text:local.text,translation:{status:'translated',language:requested,message:''}};
      // Retry only a transient translation failure, never resubmit the original
      // creation/action request (which may have side effects).
      for (let attempt=0; attempt<2; attempt++) {
        const response = await fetch('/api/contact/translate', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({text:text,language:requested}),signal:signal});
        const data = await response.json();
        if (!response.ok) {
          if (attempt===0 && [502,504].includes(response.status)) continue;
          throw new Error(data.message || 'Translation request failed');
        }
        if (data.language!==requested || typeof data.text!=='string' || !data.text.trim()) throw new Error('Invalid translation language');
        return {text:data.text,translation:{status:'translated',language:requested,message:''}};
      }
    } catch (error) { if (signal && signal.aborted) throw error; }
    return {text:text,translation:{status:'failed',language:'zh',message:'翻译暂时不可用，已保留原文。'}};
  }
  root.BeanApiTranslation = {current:current, normalize:normalize, read:read, render:render, ensure:ensure};
})(window);



//////////////////
// WEBPACK FOOTER
// ./homepage-source/bean-api-translation.js
// module id = lI6c
// module chunks = 1